/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DigitizingMelcoDigitizingModelsOrderListItem,
    DigitizingMelcoDigitizingModelsOrderListItemFromJSON,
    DigitizingMelcoDigitizingModelsOrderListItemFromJSONTyped,
    DigitizingMelcoDigitizingModelsOrderListItemToJSON,
    DigitizingMelcoModelsCustomWarning,
    DigitizingMelcoModelsCustomWarningFromJSON,
    DigitizingMelcoModelsCustomWarningFromJSONTyped,
    DigitizingMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface DigitizingMelcoModelsGenericList1MelcoDigitizingModelsOrderListItem
 */
export interface DigitizingMelcoModelsGenericList1MelcoDigitizingModelsOrderListItem {
    /**
     * 
     * @type {Array<DigitizingMelcoDigitizingModelsOrderListItem>}
     * @memberof DigitizingMelcoModelsGenericList1MelcoDigitizingModelsOrderListItem
     */
    list: Array<DigitizingMelcoDigitizingModelsOrderListItem>;
    /**
     * 
     * @type {Array<DigitizingMelcoModelsCustomWarning>}
     * @memberof DigitizingMelcoModelsGenericList1MelcoDigitizingModelsOrderListItem
     */
    warning_list?: Array<DigitizingMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof DigitizingMelcoModelsGenericList1MelcoDigitizingModelsOrderListItem
     */
    total: number;
}

export function DigitizingMelcoModelsGenericList1MelcoDigitizingModelsOrderListItemFromJSON(json: any): DigitizingMelcoModelsGenericList1MelcoDigitizingModelsOrderListItem {
    return DigitizingMelcoModelsGenericList1MelcoDigitizingModelsOrderListItemFromJSONTyped(json, false);
}

export function DigitizingMelcoModelsGenericList1MelcoDigitizingModelsOrderListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingMelcoModelsGenericList1MelcoDigitizingModelsOrderListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(DigitizingMelcoDigitizingModelsOrderListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(DigitizingMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function DigitizingMelcoModelsGenericList1MelcoDigitizingModelsOrderListItemToJSON(value?: DigitizingMelcoModelsGenericList1MelcoDigitizingModelsOrderListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(DigitizingMelcoDigitizingModelsOrderListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(DigitizingMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


